define(["require", "exports", "eventemitter2", "../../store/Events"], function (require, exports, eventemitter2_1, Events_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.emitEvent = exports.emitError = exports.notify = exports.EventManager = void 0;
    class EventManager extends eventemitter2_1.EventEmitter2 {
        constructor() {
            super({
                wildcard: true,
                delimiter: '.',
                newListener: true,
                maxListeners: 10
            });
        }
        static get Instance() {
            if (!EventManager.instance) {
                EventManager.instance = new EventManager();
            }
            return EventManager.instance;
        }
        emitRoute(path) {
            this.emit(Events_1.ROUTE_PUSH_EVENT, { pathname: path });
        }
        emitError(err) {
            this.emit(Events_1.ERROR_EVENT, err);
        }
        emitNotification(msg) {
            this.emit("notification", msg);
        }
    }
    exports.EventManager = EventManager;
    function notify(x) {
        EventManager.Instance.emitNotification(x);
    }
    exports.notify = notify;
    function emitError(err) {
        EventManager.Instance.emitError(err);
    }
    exports.emitError = emitError;
    function emitEvent(event, ...values) {
        EventManager.Instance.emitAsync(event, values);
    }
    exports.emitEvent = emitEvent;
});
